import {
    Box,
    Center,
    Image,
    Text,
    Title,
    Stack,
    Progress,
    Badge,
    Group,
    Paper,
} from "@mantine/core";

import Cdrlogo from "../../Newlogo/image.png";

const Websplash = ({ progress }) => {
    return (
        <Box
            style={{
                position: "fixed",
                inset: 0,
                zIndex: 99999,
                background:
                    "linear-gradient(135deg,#020617 0%,#0f172a 45%,#111827 100%)",
                overflow: "hidden",
            }}
        >

            {/* Glow Effects */}

            <Box
                style={{
                    position: "absolute",
                    width: 400,
                    height: 400,
                    borderRadius: "50%",
                    background: "rgba(59,130,246,0.18)",
                    filter: "blur(120px)",
                    top: -100,
                    right: -100,
                }}
            />

            <Box
                style={{
                    position: "absolute",
                    width: 350,
                    height: 350,
                    borderRadius: "50%",
                    background: "rgba(168,85,247,0.15)",
                    filter: "blur(120px)",
                    bottom: -100,
                    left: -100,
                }}
            />

            <Center h="100%">

                <Stack
                    align="center"
                    gap="xl"
                    style={{
                        width: "100%",
                        maxWidth: 500,
                        padding: 20,
                    }}
                >

                    <Badge
                        size="lg"
                        variant="light"
                        color="blue"
                        radius="xl"
                    >
                        Version 2.0
                    </Badge>

                    {/* Logo */}

                    <Paper
                        radius="100%"
                        p={20}
                        style={{
                            background: "rgba(255,255,255,0.08)",
                            border: "1px solid rgba(255,255,255,0.08)",
                            backdropFilter: "blur(20px)",
                        }}
                    >
                        <Image
                            src={Cdrlogo}
                            h={140}
                            w={140}
                            fit="contain"
                        />
                    </Paper>

                    <Stack gap={5} align="center">

                        <Title
                            c="white"
                            ta="center"
                            fw={800}
                        >
                            Court Date Reminder
                        </Title>

                        <Text c="#94a3b8">
                            Smart Legal Practice Management
                        </Text>

                    </Stack>

                    {/* Progress */}

                    <Box w="100%">

                        <Group justify="space-between" mb={8}>
                            <Text size="sm" c="#94a3b8">
                                Preparing Workspace...
                            </Text>

                            <Text size="sm" fw={700} c="white">
                                {progress}%
                            </Text>
                        </Group>

                        <Progress
                            value={progress}
                            radius="xl"
                            size="lg"
                            animated
                        />
                    </Box>

                    {/* Founders */}

                    <Paper
                        radius="xl"
                        p="md"
                        w="100%"
                        style={{
                            background: "rgba(255,255,255,0.05)",
                            border: "1px solid rgba(255,255,255,0.08)",
                        }}
                    >
                        <Text
                            size="xs"
                            c="#94a3b8"
                            ta="center"
                            mb={8}
                        >
                            Founded By
                        </Text>

                        <Text
                            ta="center"
                            fw={700}
                            c="white"
                        >
                            Adv. Abhiraj Yadav
                        </Text>
                    </Paper>

                    <Text
                        size="xs"
                        c="#64748b"
                        ta="center"
                    >
                        Powered by GV InfoTech.org
                    </Text>

                </Stack>

            </Center>
        </Box>
    );
};

export default Websplash;